import { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';
import { useAuth } from '../auth.jsx';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email.trim(), password);
      const to = location.state?.from?.pathname || '/purchase-orders';
      navigate(to, { replace: true });
    } catch (err) {
      toast.error(err.message || t('login.failed'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-100 flex items-center justify-center px-4">
      <form onSubmit={submit} className="card w-full max-w-sm p-6 space-y-4">
        <div className="text-center">
          <div className="text-xl font-semibold tracking-tight">mpo</div>
          <div className="text-xs text-zinc-500 mt-1">{t('login.subtitle')}</div>
        </div>
        <div>
          <label className="label">{t('login.email')}</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input" autoComplete="email" />
        </div>
        <div>
          <label className="label">{t('login.password')}</label>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="input" autoComplete="current-password" />
        </div>
        <button type="submit" disabled={busy} className="btn-primary w-full">
          {busy ? t('login.signingIn') : t('login.signIn')}
        </button>
        <div className="text-center text-xs text-zinc-500">
          <Link to="/register" className="hover:text-zinc-300">{t('login.firstTime')}</Link>
        </div>
      </form>
    </div>
  );
}
